import React, { useEffect, useState } from 'react'
import SideNavClass from './SideNavClass'
import { isMobile } from 'react-device-detect';
import { MDBCard, MDBCardBody, MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { Download, Draft, FinalCopy, Upload, Vector1 } from '../../components/images/ClassAssets';
// import ucheckInImg from "./../components/images/user-checkin.svg";
import ucheckInImg from "../../components/images/user-checkin.svg";
import Tclass from "../../components/images/totalclasses.svg";
import Tbooking from "../../components/images/totalbooking.svg";
import Tscheduling from "../../components/images/totalscheduling.svg";
import { getclassDashboardInfo } from '../../services/classApiServices.js';
import greenImg from "../../components/images/green.svg";
import payRImg from "../../components/images/Payments-received.svg";
import payPImg from "../../components/images/payments-pending.svg";
import { useAccess } from '../../context/AccessContext';

const ClassDashboard = () => {

    const [modeOpen, setModeOpen] = useState(true);
    const [mode, setMode] = useState('side');
    const { loading, handlePageAccess, fetchAccess } = useAccess();
    const roleAccess = handlePageAccess("dashboard")
    useEffect(() => {
        if (isMobile) {
            setModeOpen(false)
            setMode("over")
        }
    }, [])

    const sideNav = () => {
        setModeOpen(!modeOpen);
        if (isMobile) {
            setMode("over")
        } else {
            setMode("side")
        }
    }

    const [dashboardInfo, setDashboardInfo] = useState()
    useEffect(() => {

        const fetchData = async () => {

            const response = await getclassDashboardInfo(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid);
            if (!response || response === "false") {
                return;
            }
            const dashboardInfo = await response.json();

            console.log(dashboardInfo, 'dashboardInfo');
            setDashboardInfo(dashboardInfo)
            // setRefresh(false)
            // setApplyFilterClicked(false)
            // setResetFilterClicked(false)
        }
        if (localStorage.getItem("loggedUserInfo")) {
            fetchData()
        }
    }, [])

    return (
        <>
            <SideNavClass activeTab={"classdashboard"} modeOpen={modeOpen} setModeOpen={setModeOpen} mode={mode} setMode={setMode} >

                {isMobile && <>

                    <header class="gym-container gym-hide-large gym-red  gym-padding d-flex align-items-center p-3">
                        <div onClick={() => sideNav()} className='cursor-pointer'>
                            <MDBIcon fas icon='bars' size='lg' />
                        </div>
                        <h5 class="ms-3 mb-0 d-inline">EasyMembr</h5>
                    </header>

                </>}

                <MDBCard className='shadow-3 overflow-hidden'>
                    <MDBCardBody className='custom-card-height'>

                        <h5 className='m-0'>
                            Dashboard
                        </h5>
                        <MDBRow>
                            <MDBCol sm={12} md={6} lg={3} className='pe-0'>
                                <div class="card mb-0 card-gym  p-3" style={{ height: "150px" }}>
                                    <div class="d-flex flex-column justify-content-between h-100">
                                        <div class="d-flex space-between  col-lg-12">
                                            <h5 class="card-title ">Total Classes</h5>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="col-md-9 col-sm-9">
                                                <div class="">
                                                    <h2 class="clr-main"> {dashboardInfo?.classCount ? dashboardInfo.classCount : 0} </h2>

                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 d-flex justify-end">
                                                <img
                                                    className='ClassescardImage '
                                                    src={Tclass}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>


                            <MDBCol sm={12} md={6} lg={3} className='pe-0'>
                                <div class="card mb-0 card-gym  p-3" style={{ height: "150px" }}>
                                    <div class="d-flex flex-column justify-content-between h-100">
                                        <div class="d-flex space-between  col-lg-12">
                                            <h5 class="card-title ">Total Schedules</h5>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="col-md-9 col-sm-9">
                                                <div class="">
                                                    <h5 class="clr-main"> {dashboardInfo?.totalEvents ? dashboardInfo.totalEvents : 0} <button class="button-link link-color"></button></h5>

                                                    <div class="d-flex space-between count_status"><p className='m-0'>Active Schedules </p><p className='m-0 text-success fw-bold'>{dashboardInfo?.activeEvents ? dashboardInfo.activeEvents : 0}</p></div>
                                                    <div class="d-flex space-between count_status"><p className='m-0'>Inactive Schedules </p><p className='m-0 text-danger fw-bold'>{dashboardInfo?.inactiveEvents ? dashboardInfo.inactiveEvents : 0}</p></div>

                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 d-flex justify-end">
                                                <img
                                                    className='ClassescardImage'
                                                    src={Tbooking}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>


                            <MDBCol sm={12} md={6} lg={3} className='pe-0'>
                                <div class="card mb-0 card-gym  p-3" style={{ height: "150px" }}>
                                    <div class="d-flex flex-column justify-content-between h-100">
                                        <div class="d-flex space-between  col-lg-12">
                                            <h5 class="card-title ">Total Bookings</h5>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="col-md-9 col-sm-9">
                                                <div class="">
                                                    <h2 class="clr-main"> {dashboardInfo?.totalBookedSlots ? dashboardInfo.totalBookedSlots : 0} <button class="button-link link-color"></button></h2>

                                                    {/* <div class="d-flex space-between"><p className='m-0'>Active Bookings </p><p className='m-0 text-success fw-bold'>12</p></div>
                                                    <div class="d-flex space-between"><p className='m-0'>Inactive Schedules </p><p className='m-0 text-danger fw-bold'>08</p></div> */}

                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 d-flex justify-end">
                                                <img
                                                    className='ClassescardImage'
                                                    src={Tscheduling}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={3} className='pe-0'>
                                <div class="card mb-0 card-gym  p-3" style={{ height: "150px" }}>
                                    <div class="d-flex flex-column justify-content-between h-100">
                                        <div class="d-flex space-between  col-lg-12">
                                            <h5 class="card-title ">Payment Received</h5>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="col-md-9 col-sm-9">
                                                <div class="">
                                                    <h2 class="clr-main">
                                                        <img className="paymt-rec" src={greenImg} alt="" />
                                                        {dashboardInfo?.amountReceived ? dashboardInfo.amountReceived : 0}
                                                        <button class="button-link link-color"></button></h2>

                                                    {/* <div class="d-flex space-between"><p className='m-0'>Active Bookings </p><p className='m-0 text-success fw-bold'>12</p></div>
                                                    <div class="d-flex space-between"><p className='m-0'>Inactive Schedules </p><p className='m-0 text-danger fw-bold'>08</p></div> */}

                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 d-flex justify-end payimg">
                                                <img
                                                    className="h-103"
                                                    src={payRImg}
                                                    alt="Trendy Pants and Shoes"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>

                            <MDBCol sm={12} md={6} lg={3} className='pe-0'>
                                <div class="card mb-0 card-gym  p-3" style={{ height: "150px" }}>
                                    <div class="d-flex flex-column justify-content-between h-100">
                                        <div class="d-flex space-between  col-lg-12">
                                            <h5 class="card-title ">Refund Amount</h5>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div class="col-md-9 col-sm-9">
                                                <div class="">
                                                    <h5 class="clr-main">{dashboardInfo?.
                                                        refundobject?.
                                                        totalRefundAmount
                                                        ? dashboardInfo?.
                                                            refundobject?.
                                                            totalRefundAmount
                                                        : 0}</h5>

                                                    <div class="d-flex space-between count_status"><p className='m-0'>Refund Pending </p><p className='m-0 text-warning fw-bold'>{dashboardInfo?.
                                                        refundobject?.
                                                        totalRefundAmount
                                                        ? dashboardInfo?.
                                                            refundobject?.
                                                            inProgressAmount
                                                        : 0}</p></div>
                                                    <div class="d-flex space-between count_status"><p className='m-0'>Refund Settled </p><p className='m-0 text-success fw-bold'>{dashboardInfo?.
                                                        refundobject?.
                                                        proceedAmount
                                                        ? dashboardInfo?.
                                                            refundobject?.
                                                            proceedAmount : 0}</p></div>

                                                </div>
                                            </div>
                                            <div class="col-md-3 col-sm-3 d-flex justify-end payimg">
                                                <img
                                                    className="h-103"
                                                    src={payPImg}
                                                    alt="Trendy Pants and Shoes"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>





            </SideNavClass>
        </>
    )
}

export default ClassDashboard
